import { render, staticRenderFns } from "./LoanHeader.vue?vue&type=template&id=6b8ed778&"
import script from "./LoanHeader.vue?vue&type=script&lang=js&"
export * from "./LoanHeader.vue?vue&type=script&lang=js&"
import style0 from "./LoanHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports